import { GrantedPermissionSet, GrantedPermissionSetResolver } from '../../right.service';
import { OperationRights } from '../../../app.right-definitions';

export class LedgerNumberRightModel {

  public readonly create: GrantedPermissionSet;
  public readonly read: GrantedPermissionSet;
  public readonly update: GrantedPermissionSet;
  public readonly disable: GrantedPermissionSet;

  constructor(resolver: GrantedPermissionSetResolver) {
    this.create = resolver.of(OperationRights.LEDGER_NUMBER_CREATE);
    this.read = resolver.of(OperationRights.LEDGER_NUMBER_READ);
    this.update = resolver.of(OperationRights.LEDGER_NUMBER_UPDATE);
    this.disable = resolver.of(OperationRights.LEDGER_NUMBER_DISABLE);
  }
}
